import React from 'react'
import { Card, Row, Col, theme, Badge, Statistic } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBuilding,
  faUserMd,
  faCalendarAlt,
  faChartLine,
  faCog,
  faFileInvoiceDollar,
  faUsers,
  faClipboardList,
  faExclamationTriangle,
  faBell
} from '@fortawesome/free-solid-svg-icons'

const QuickActions = () => {
  const { token } = theme.useToken()

  const actionCards = [
    {
      id: 'facilities',
      title: 'Facilities Overview',
      description: 'Manage all your facilities and locations',
      icon: faBuilding,
      color: '#475569',
      stats: { value: 5, label: 'Active Facilities' }
    },
    {
      id: 'staff',
      title: 'Staff Management',
      description: 'View and manage medical professionals',
      icon: faUserMd,
      color: '#475569',
      stats: { value: 23, label: 'Active Staff' }
    },
    {
      id: 'appointments',
      title: 'Appointments Hub',
      description: 'Overview of all facility appointments',
      icon: faCalendarAlt,
      color: '#475569',
      stats: { value: 142, label: 'Today' }
    },
    {
      id: 'analytics',
      title: 'Performance Analytics',
      description: 'Reports and insights across facilities',
      icon: faChartLine,
      color: '#475569',
      stats: { value: '87%', label: 'Efficiency' }
    },
    {
      id: 'billing',
      title: 'Financial Overview',
      description: 'Billing and revenue management',
      icon: faFileInvoiceDollar,
      color: '#475569',
      stats: { value: 'R24.5k', label: 'Today' }
    },
    {
      id: 'patients',
      title: 'Patient Management',
      description: 'Patient records across all facilities',
      icon: faUsers,
      color: '#475569',
      stats: { value: 1847, label: 'Total Patients' }
    },
    {
      id: 'reports',
      title: 'System Reports',
      description: 'Operational reports and compliance',
      icon: faClipboardList,
      color: '#475569',
      stats: { value: 3, label: 'Pending' }
    },
    {
      id: 'alerts',
      title: 'System Alerts',
      description: 'Notifications and important updates',
      icon: faExclamationTriangle,
      color: '#dc2626',
      badge: 2,
      stats: { value: 2, label: 'Critical' }
    }
  ]

  const handleCardClick = (actionId) => {
    // Placeholder for future functionality
  }

  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <h2
          style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#1e293b',
            margin: 0,
            marginBottom: '8px'
          }}
        >
          Quick Actions
        </h2>
        <p
          style={{
            fontSize: '14px',
            color: '#64748b',
            margin: 0
          }}
        >
          Access key management functions and insights
        </p>
      </div>

      <Row gutter={[16, 16]}>
        {actionCards.map((card) => (
          <Col xs={24} sm={12} lg={12} xl={8} key={card.id}>
            <Card
              hoverable
              onClick={() => handleCardClick(card.id)}
              style={{
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                position: 'relative',
                height: '140px'
              }}
              bodyStyle={{ padding: '20px' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'
                e.currentTarget.style.borderColor = '#cbd5e1'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.12)'
                e.currentTarget.style.borderColor = '#e2e8f0'
              }}
            >
              {/* Badge for alerts */}
              {card.badge && (
                <Badge
                  count={card.badge}
                  style={{
                    position: 'absolute',
                    top: '12px',
                    right: '12px',
                    zIndex: 10
                  }}
                />
              )}

              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                {/* Icon */}
                <div
                  style={{
                    width: '44px',
                    height: '44px',
                    background: '#f1f5f9',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}
                >
                  <FontAwesomeIcon
                    icon={card.icon}
                    style={{
                      color: card.color,
                      fontSize: '18px'
                    }}
                  />
                </div>

                {/* Content */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3
                    style={{
                      color: '#1e293b',
                      margin: 0,
                      fontSize: '16px',
                      fontWeight: '600',
                      marginBottom: '4px',
                      lineHeight: '1.3'
                    }}
                  >
                    {card.title}
                  </h3>

                  <p
                    style={{
                      color: '#64748b',
                      margin: 0,
                      fontSize: '13px',
                      lineHeight: '1.4',
                      marginBottom: '12px'
                    }}
                  >
                    {card.description}
                  </p>

                  {/* Stats */}
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                    <span
                      style={{
                        fontSize: '18px',
                        fontWeight: '700',
                        color: card.id === 'alerts' ? '#dc2626' : '#1e293b'
                      }}
                    >
                      {card.stats.value}
                    </span>
                    <span
                      style={{
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#64748b'
                      }}
                    >
                      {card.stats.label}
                    </span>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default QuickActions
